module.exports = __webpack_public_path__ + "img/delete-icon.a5e90d23.svg";